import styled from 'styled-components';

import { brandColors } from 'styles/colors';

import { CheckboxCheckedIcon } from 'components/icons';

export const Wrapper = styled.span`
	position: relative;
	outline: none;
	background: none;
`;

export const StyledCheckboxCheckedIcon = styled(CheckboxCheckedIcon)`
	fill: ${brandColors.green};
`;
